import store from '@/store/store';

const ROLE_CRM_ADMINISTRATOR =  'Furness CRM Administrator';
const ROLE_FACILITY_ADMINISTRATOR =  'Furness Facility Administrator';
const ROLE_PORTAL_ADMINISTRATOR =  'Furness Portal Administrator';

const PERMISSION_ADMIN = 'admin';
const PERMISSION_BASIC = 'basic'; // All pages mainly

const PERMISSION_NEW_MAIN_ENTITY = 'new main entity';
const PERMISSION_OLD_MAIN_ENTITY = 'old main entity';

const roles = [
  {
    role: ROLE_CRM_ADMINISTRATOR,
    permissions: [
      PERMISSION_OLD_MAIN_ENTITY,
    ],
    defaultRoute: 'dashboard',
  },
  {
    role: ROLE_FACILITY_ADMINISTRATOR,
    permissions: [
      PERMISSION_NEW_MAIN_ENTITY,
    ],
    defaultRoute: 'dashboard',
  },
  {
    role: ROLE_PORTAL_ADMINISTRATOR,
    permissions: [
      PERMISSION_ADMIN,
    ],
    defaultRoute: 'dashboard',
  },
]

const getDefaultRouteForRole = (givenRole) => roles.find(({role}) => givenRole === role).defaultRoute;

/**
 * Checks if a user has access based on their roles
 * @param permissions
 * @param userRoles
 * @returns {boolean}
 */
const hasAccessTo = (permissions, userRoles) => {
  if (!permissions || permissions === 'undefined') {
    return true;
  }

  // Default
  if (!userRoles) {
    userRoles = store.getters['auth/userRoles'];
  }

  // Get list of all permissions that the user has based on their roles
  const allPermissions =  roles.filter(({role}) => userRoles.includes(role))
    .flatMap(r => r.permissions);


  // Can do everything
  if (allPermissions.includes(PERMISSION_ADMIN)) {
    return true;
  }

  // Force an array
  if (!Array.isArray(permissions)) {
    permissions = [permissions];
  }

  const doCheck = (permission, userPerms) => userPerms.includes(permission);

  let hasAccess = false;

  // Loop through each, is an OR rather than AND
  permissions.forEach(p => {
    if (hasAccess) {
      return true;
    }

    hasAccess = doCheck(p, allPermissions);
  })

  return hasAccess;
};

export {
  hasAccessTo,
  getDefaultRouteForRole,
  ROLE_CRM_ADMINISTRATOR,
  ROLE_FACILITY_ADMINISTRATOR,
  ROLE_PORTAL_ADMINISTRATOR,
  PERMISSION_ADMIN,
  PERMISSION_BASIC,
  PERMISSION_NEW_MAIN_ENTITY,
  PERMISSION_OLD_MAIN_ENTITY,
};

export default roles;
